import { ConstantesService } from './../../shared/services/constantes.service';
import { ConfirmationModalOptions } from './../../shared/models/modal.model';
import { OnInit, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
    selector: 'app-registro-salida-modal',
    templateUrl: './registro-salida-modal.component.html',
    styleUrls: ['./registro-salida-visitante.component.scss']
})
export class RegistroSalidaModalComponent{

    @Input() InformacionVisitante: any;

    public modalOptionsSalida: ConfirmationModalOptions;
    public modalOptionsParcial: ConfirmationModalOptions;

    constructor(private activeModal: NgbActiveModal) {
        this.modalOptionsSalida =
            new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONFIRM_REGISTRO_SALIDA,
                'SI', 'NO', 'fas fa-sign-out-alt', false, false, 'Registrar Salida', null, 'btn-secondary pull-left');
        this.modalOptionsParcial =
            new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONFIRM_REGISTRO_SAL_PARCIAL,
                'SI', 'NO', 'fas fa-sign-out-alt', false, false, 'Registrar Salida Parcial', null, 'btn-secondary pull-right');

    }

    // fromero
    // método para cerrar el modal activo y envíar lista de visitas a formulario de agenda
    // 26/04/2019
    close(tipo) {
        this.activeModal.close({ accion: tipo[1], respuesta: tipo[0] });

        // emite la lista de agendas que se ingresaron en el modal
    }

    // fromero
    // método handler del modal de confirmación
    // 16 /05/2019
    getConfirmationModalResponse(event) {
        this.close(event);
    }
}
